"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeQueryParam = exports.toQueryParam = void 0;
var toQueryParam = function (key, val) {
    return encodeURIComponent(key) + "=" + encodeURIComponent(val);
};
exports.toQueryParam = toQueryParam;
var makeQueryParam = function (key, val) {
    if (typeof val === 'object') {
        return (Object.keys(val)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map(function (objKey) { return encodeURIComponent(key) + "." + objKey + "=" + encodeURIComponent(val[objKey]); })
            .join('&'));
    }
    return toQueryParam(key, val);
};
exports.makeQueryParam = makeQueryParam;
//# sourceMappingURL=query.js.map